module.exports = __webpack_public_path__ + "dcbd1189c7844044b764019d0d72a909.svg";